import React, { useContext } from 'react';
import TodoListContext from '~/App/Modules/TodoList/Context';
import AssigneeContext from '~/App/Contexts/AssigneeContext';
import { TeamMemberSelector } from '~/App/Components/Filters/TeamMemberSelector';
import { SortToggler } from '~/App/Components/Filters/SortToggler';
import { CreateNewGreetButton } from './CreateNewGreetButton';
import { UserSimple } from '~/types/models';
import { get } from 'lodash';
import useCurrentUser from '~/react-hooks/use-current-user';

export function Header() {
  const { id: userId } = useCurrentUser();
  const { setAssignee, assignee } = useContext(TodoListContext);

  const assigneeContext = {
    assignee,
    setAssignee,
  };

  const selectedAssignee = get(assignee, userId);

  function onUserSelect(user?: UserSimple) {
    setAssignee({ ...assignee, [userId]: user ?? null });
  }
  return (
    <AssigneeContext.Provider value={assigneeContext}>
      <div className='flex flex-col w-full'>
        <div className='flex flex-row px-5 py-2.5 w-full justify-center shadow gap-x-2 z-50'>
          <TeamMemberSelector
            selectedUser={selectedAssignee}
            onSelect={onUserSelect}
          />
          <SortToggler />
        </div>
        <CreateNewGreetButton />
      </div>
    </AssigneeContext.Provider>
  );
}

export default Header;
